import { render } from "./KoreanPage.vue?vue&type=template&id=fbac9508&scoped=true"
import script from "./KoreanPage.vue?vue&type=script&lang=js"
export * from "./KoreanPage.vue?vue&type=script&lang=js"

import "./KoreanPage.vue?vue&type=style&index=0&id=fbac9508&scoped=true&lang=css"

import exportComponent from "/Users/johnahnz0rs/00 - JAHN PROJECTS/frequency-lists/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fbac9508"]])

export default __exports__